import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PointOfSaleService } from '../../../point-of-sale.service';
import { POINT_OF_SALE_TTL_ES } from '../../../point-of-sale.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { BranchStoreSelected } from 'src/app/pages/gestion/branch-stores/components/details/branch-store-details.component';

@Component({
  selector: 'pg-point-of-sale-create',
  templateUrl: './point-of-sale-create.component.html'
})
export class PointOfSaleCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  branchStoreSelected = new BranchStoreSelected('Sucursal del punto de venta');
  constructor(
    private fb: FormBuilder,
    private pointOfSaleService: PointOfSaleService
  ) {
    super(POINT_OF_SALE_TTL_ES, pointOfSaleService);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      code: ['', [Validators.required]],
      seriesOfReceipts: ['', [Validators.required]]
    });
  }

  onSubmit() {
    if (this.isReadyToCreate()) {
      this.createItem$(this.parseData(this.fg.value));
    }
  }

  parseData(form) {
    return {
      ...form,
      branchStoreId: this.branchStoreSelected.getId()
    };
  }

  isReadyToCreate() {
    return this.fg.valid && this.branchStoreSelected.value;
  }
}
